import PropTypes from 'prop-types';
import React from 'react';

import { VideoCameraIcon } from '@heroicons/react/solid';
import noop from 'lodash/noop';

import Modal from 'components/Modal';
import Button from 'components/buttons/Button';

const CompanyVideoDeleteModal = ({
  open = false,
  title = '',
  onClose = noop,
  onDelete = noop,
}) => (
  <Modal open={open}>
    <Modal.Icon Icon={VideoCameraIcon} />

    <Modal.Title>Delete video</Modal.Title>
    <Modal.Description>
      Are you sure you want to delete video: <b>{title}</b>
    </Modal.Description>
    <Modal.RightButtons>
      <Button type="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onDelete}
        eventType="pressPage_update"
        eventProperties={{ action: 'video_delete' }}
        data-test-id="company-videos-deleteModal-delete"
      >
        Delete video
      </Button>
    </Modal.RightButtons>
  </Modal>
);

CompanyVideoDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CompanyVideoDeleteModal;
